<template>
  <div class="forms__field-wrapper input-date" :class="extraClasses">
    <p class="field-description" v-if="fieldData.description" v-html="fieldData.description"/>
    <p class="forms__help-text" v-if="helpText.length > 0">{{ helpText }}</p>
    <div class="input-wrapper" :class="{ 'error': showFormError,  'required': required }">
      <input class="input"
        type="date"
        :id="id"
        :required="required"
        v-model="value"
        @blur="validateField"
      />
      <label class="floating-label" :for="id">{{ label }}</label>
      <p class="forms__error-message" 
        v-t="'errors.required_field'"
        v-if="showFormError"
        role="alert"/>
    </div>
  </div>
</template>
<script>
import AbstractField from "@/util/AbstractField";

export default {
  name: "date",
  mixins: [AbstractField],
};
</script>